import { Redirect } from 'react-router-dom';
import { RouteConfig } from 'react-router-config';
import { TemplateEmpty } from './templates/empty';
import { SelectStudioRouter } from '../pages/studio/select-studio-router';
import { STUDIO_ROUTE } from './studio';
import { CONSOLE_ROUTE } from './console';
// import { ACCOUNT_ROUTE } from './account-center';
// import { ORGANIZATION_ROUTE } from './organization';
import { DOCUMENT_ROUTE } from './document-detail';
import { ADMIN_ROUTE } from './admin';
import { DOWNLOAD_ROUTE } from './download-center';
import { PRICE_ROUTE } from './price-calculate';
import { NotFound } from '../pages/not-found';
import { NoPermission } from '../pages/component/permission-check/no-permission';
import { isSupportSystem } from '../config';

const NOT_FOUND_ROUTE: RouteConfig[] = [
  {
    path: '/404',
    exact: true,
    component: NotFound,
  },
  {
    path: '*',
    render: () => <Redirect to={'/404'} />,
  },
];

let childRoutes: RouteConfig[] = [
  {
    path: '/',
    exact: true,
    component: SelectStudioRouter,
  },
  {
    path: '/403',
    component: NoPermission,
  },

  ...STUDIO_ROUTE,
  ...CONSOLE_ROUTE,
  // ...ACCOUNT_ROUTE,
  // ...ORGANIZATION_ROUTE,
  ...DOCUMENT_ROUTE,
  ...DOWNLOAD_ROUTE,
  ...PRICE_ROUTE,
  ...ADMIN_ROUTE,
  ...NOT_FOUND_ROUTE, // NOT_FOUND_ROUTE 需要放到最后
];

if (isSupportSystem()) {
  childRoutes = [
    {
      path: '/',
      exact: true,
      render: () => <Redirect to={'/admin/service'} />,
    },
    {
      path: '/403',
      component: NoPermission,
    },
    ...ADMIN_ROUTE,
    ...NOT_FOUND_ROUTE,
  ];
}

const ROUTES_CONFIG: RouteConfig[] = [
  {
    path: '/',
    component: TemplateEmpty,
    routes: childRoutes,
  },
];

export default ROUTES_CONFIG;
